/**
 * Reading progress bar — tracks scroll through the article body and pins the bar
 * to the bottom edge of the sticky blog header (height varies by breakpoint).
 */
function init() {
    var fill = document.getElementById('blog-progress-fill');
    var body = document.getElementById('post-body');
    var bar  = document.querySelector('.blog-progress');
    if (!fill || !body || !bar) { return; }

    var header = document.querySelector('.blog-header');

    var ticking = false;
    function update() {
        ticking = false;
        if (header) {
            bar.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
        }
        var total = body.offsetHeight - window.innerHeight;
        var scrolled = -body.getBoundingClientRect().top;
        var pct = total > 0 ? Math.min(100, Math.max(0, (scrolled / total) * 100)) : 0;
        fill.style.width = pct + '%';
    }
    function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
}

module.exports = { init };
